import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./error.html";
import { PARTNER_COMMUNITY_URL, SUPPORT_URL } from '~/config';
import { WireI18n } from '~/modules/stores/i18nStore';
import { routerStore } from '~/modules/stores/routerStore';
import { images } from '~/modules/utilities/assetUtilities';
import { ERROR_CODES } from '~/modules/utilities/errorUtilities';
import { logger } from '~/modules/utilities/logger';
import { sanitize } from '~/modules/utilities/stringUtilities';
class ErrorPage extends LightningElement {
  constructor(...args) {
    super(...args);
    this.appName = void 0;
    this.labels = {};
    this.sharedLabels = {};
    this.images = images;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.errorPage;
    this.sharedLabels = i18n.shared;
    this.appName = i18n.globalHeader.appName;
  }
  connectedCallback() {
    const errorCode = parseInt(this.errorCode);
    const [errorName] = Object.entries(ERROR_CODES).find(([, code]) => code === errorCode) || [];
    const error = errorName || this.errorCode;
    const referrerSanitized = sanitize(document.referrer);
    logger.error(`Landed on Error Page with error '${error || 'unknown'}', from '${referrerSanitized || 'unknown'}'`);
  }
  get errorCode() {
    const queryString = routerStore.getState().queryString;
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const code = params.get('code');
      if (code != null && code !== '') {
        return code;
      }
    }
    return 'UNKNOWN';
  }
  handleSupport() {
    window.location.assign(SUPPORT_URL);
  }
  handleBack() {
    window.location.assign(PARTNER_COMMUNITY_URL);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ErrorPage, {
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["appName", "labels", "sharedLabels", "images"]
});
const __lwc_component_class_internal = _registerComponent(ErrorPage, {
  tmpl: _tmpl,
  sel: "pages-error",
  apiVersion: 62
});
export default __lwc_component_class_internal;